import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { controlPlaneApi } from '@services/controlPlaneApi';
import projectReducer from './slices/projectSlice';
import sessionReducer from './slices/sessionSlice';
import uiReducer from './slices/uiSlice';
import aiReducer from './slices/aiSlice';
import historyReducer from './slices/historySlice';
import preferencesReducer from './slices/preferencesSlice';
import geometryReducer from './slices/geometrySlice';
import studyReducer from './slices/studySlice';
import runReducer from './slices/runSlice';
import probeReducer from './slices/probeSlice';

export const store = configureStore({
  reducer: {
    [controlPlaneApi.reducerPath]: controlPlaneApi.reducer,
    project: projectReducer,
    session: sessionReducer,
    ui: uiReducer,
    ai: aiReducer,
    history: historyReducer,
    preferences: preferencesReducer,
    geometry: geometryReducer,
    study: studyReducer,
    run: runReducer,
    probe: probeReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Redux Toolkit checks: strict serializability enforced across all actions
        warnAfter: 64
      }
    }).concat(controlPlaneApi.middleware)
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
